module.exports = "/fast-coin/img/coin/anim/in/coin_in_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_024.png
// module id = 2294
// module chunks = 5